import React, { useContext, useEffect, useState } from 'react'
import { CloseChatContext } from './ComplateMessages';
import InfiniteScroll from "react-infinite-scroll-component";
import { Fragment } from 'react';


function FilterBody() {
    const { state, dispatch } = useContext(CloseChatContext)

    const handleClickMessage = (id) => {
        dispatch({
            type: 'ACTIVE',
            active: id
        })
    }

    const fetchMoreData = () => {
        dispatch({
            type: 'TRIGGER',
            trigger: { message: 'reload-chats' }
        })
    }

    const initialState = (
        <div className="card-body">
            <div className="empty-state" data-height="400">
                <div className="empty-state-icon">
                    <i className="fas fa-question"></i>
                </div>
                <h2>We couldn't find any data</h2>
                <p className="lead">
                    Sorry we can't find any data, to get rid of this message, make at least 1 entry.
                </p>
            </div>
        </div>
    )
    const [renderChat, setrenderChat] = useState(initialState)
    useEffect(() => {
        if (state.chats.length > 0 || state.trigger.message === 'reload-filter-body') {
            function renderStar(count) {
                const star = []
                for (var i = 0; i < 5; i++) {
                    star.push(<i className="fas fa-star" style={{ color: `${i < count ? 'yellow' : '#fff'}`, textShadow: '-1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000' }} key={i} />)
                }
                return star
            }

            setrenderChat(<Fragment >
                <div id="scrollableDiv" style={{ height: '100%', overflow: 'auto', }}>
                    <InfiniteScroll
                        dataLength={state.chats.length}
                        next={fetchMoreData}
                        hasMore={true}
                        endMessage={
                            <p style={{ textAlign: "center" }}>
                                <b>Yay! You have seen it all</b>
                            </p>
                        }
                        scrollableTarget="scrollableDiv"
                    >
                        {state.chats.map((chat, index) =>
                            <div key={chat.id} onClick={() => handleClickMessage(chat.id)}>
                                <div className={`ticket-item pr-2 pt-3 pl-2 pb-1 ${state.active == chat.id ? `active` : ''}`} >
                                    <div className="row col-12 pr-1" >
                                        <div className="col-auto">
                                            <div className="avatar-item">
                                                <img alt="image" src="../assets/img/avatar/avatar-1.png" className="img-fluid pr-0" width="50" data-toggle="tooltip" title={chat.username} />
                                                {chat.admin != null ? (<div className="avatar-badge" title={chat.admin} data-toggle="tooltip"><img src="../assets/img/avatar/avatar-3.png" width="20" alt="" /></div>) : ''}
                                            </div>
                                        </div>
                                        <div className="media-body col-mx-auto  pl-0 ml-0 mr-0 pr-0">
                                            <div className="ticket-title  mb-0 pb-0">
                                                <b style={{ fontSize: '0.8em', marginBottom: '0px' }}>{chat.username} <small className="pt-1" style={{ float: 'right', fontSize: '0.7em' }}>{`${new Date(chat.time).toISOString().replace(/T/, ' ').replace(/\..+/, '').substring(0, new Date(chat.time).toISOString().replace(/T/, ' ').replace(/\..+/, '').length - 3)}`}</small> </b>
                                            </div>
                                            <div style={{ float: 'right' }}>
                                                {chat.ratting != null ? renderStar(chat.ratting) : ''}
                                            </div>
                                            <div className="ticket-desc mb-0  pb-0">
                                                <div className="mb-0">
                                                    <p style={{ fontSize: '1.2em', marginBottom: '0px' }}>{chat.category.name}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </InfiniteScroll>
                </div>
            </Fragment>)
        } else {
            setrenderChat(
                <div className="card-body">
                    <div id="scrollableDiv" style={{ height: '100%', overflow: 'auto', }}>
                        <InfiniteScroll
                            dataLength={0}
                            next={''}
                            hasMore={false}
                            scrollableTarget="scrollableDiv"
                        >
                            <div className="empty-state" data-height="400">
                                <div className="empty-state-icon">
                                    <i className="fas fa-envelope-open-text"></i>
                                </div>
                                <h2>No New Messages</h2>
                                <p className="lead">
                                    All messages have been replied to.
                                </p>
                            </div>
                        </InfiniteScroll>
                    </div>
                </div>
            )
        }
    }, [state.chats, state.trigger, state.active])

    useEffect(() => {
        if (state.trigger.message == "get-chat-load") {
            setrenderChat(
                <div className="card-body">
                    <div className="empty-state" data-height="400">
                        <div className="empty-state-icon">
                            <i className="fas fa-spinner fa-pulse"></i>
                        </div>
                        <h2>Get Chat</h2>
                        <p className="lead">
                            ... loading
                        </p>
                    </div>
                </div>
            )
        } else if (state.trigger.message == "get-chat-category") {
            //clear chats
            setrenderChat(
                <div className="card-body">
                    <div className="empty-state" data-height="400">
                        <div className="empty-state-icon">
                            <i className="fas fa-spinner fa-pulse"></i>
                        </div>
                        <h2>... loading</h2>
                        <p className="lead">
                            {state.filter == 'search' ? 'Type at least a keyword  ' : 'Choose Category'}
                        </p>
                    </div>
                </div>
            )
        }
    }, [state.trigger])
    return (
        <div className="card-body chat-content-chat pl-0 pr-2 overflow-auto" >
            {renderChat}
        </div>
    )
}

export default FilterBody
